export default __webpack_public_path__ + "static/media/imagePVI_2.0aef701a.png";